import { DateTime } from '@ksyos/date-time';
import type { SubTrack } from '@common/interfaces/api/fundingProcessApi';

export function canSubTrackBeExported<T extends Pick<SubTrack, 'endDate' | 'startDate'>>(subTrack: T) {
    return DateTime.from(subTrack.endDate).isBefore(DateTime.now());
}
